import {UntypedFormGroup, ValidatorFn} from '@angular/forms';

export const isPastDateDirective: ValidatorFn = (control: UntypedFormGroup): { [key: string]: any } | null => {
  const today = new Date().setHours(0,0,0,0);
  const value = new Date(control.value).setHours(0,0,0,0);
  if (control.value != null && value >= today) {
    return {pastDateInvalid: true};
  }
  return null;
};
